import { IframeHTMLAttributes } from 'react';
import { cn } from '@virginexperiencedays/tailwind';
import { Location } from '@virginexperiencedays/products';

type GoogleEmbedProps = IframeHTMLAttributes<HTMLIFrameElement> & {
  API_KEY: string;
  location: Location;
  className?: string;
};

export const GoogleEmbedMap = ({ API_KEY, location, className, ...props }: GoogleEmbedProps) => {
  return (
    <iframe
      className={cn('rounded border-0', className)}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
      src={`https://www.google.com/maps/embed/v1/place?key=${API_KEY}
      &q=${encodeURIComponent(location.lat)}, ${encodeURIComponent(location.lng)}&zoom=10`}
      title={`${location.lat},${location.lng}`}
      {...props}
    />
  );
};
